export function referenceField(valueA, valueB) {
    if (valueA == null && valueB == null) {
        return 0;
    }
    if (valueA == null && valueB != null) {
        return 1;
    }
    if (valueA != null && valueB == null) {
        return -1;
    }
    if (valueA > valueB) {
        return 1;
    }
    if (valueA < valueB) {
        return -1;
    }
    return 0;
}
